import IconBase from "../IconBase";

const SaveIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M6 20H18M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default SaveIcon;
